import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ahaApi from "../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const addStatOrders = createAsyncThunk(
  "statOrders/addStatOrders",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.addOrder(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const addStatOrdersSlice = createSlice({
  name: "addStatOrders",
  initialState,
  reducers: {
    clearAddStatOrderResponse(state, action) {
      state.value = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addStatOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(addStatOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(addStatOrders.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const addStatOrdersList = (state) => state.addStatOrders.value;
export const { clearAddStatOrderResponse } = addStatOrdersSlice.actions;
export default addStatOrdersSlice.reducer;
